/**
 * Auth API endpoints — T20.
 * Maps PRD §9.1 to typed fetch calls via apiClient.
 */
import {
  LoginResponseSchema,
  LogoutResponseSchema,
  MeResponseSchema,
  RefreshResponseSchema,
} from '@malaberg/shared';
import { apiClient } from '../client';

export const authApi = {
  login(email: string, password: string) {
    return apiClient.request('POST', '/api/auth/login', {
      body: JSON.stringify({ email, password }),
      skipAuth: true,
      schema: LoginResponseSchema,
    });
  },

  logout() {
    return apiClient.request('POST', '/api/auth/logout', {
      schema: LogoutResponseSchema,
    });
  },

  refresh() {
    return apiClient.request('POST', '/api/auth/refresh', {
      skipAuth: true,
      schema: RefreshResponseSchema,
    });
  },

  me() {
    return apiClient.request('GET', '/api/auth/me', {
      schema: MeResponseSchema,
    });
  },

  changePassword(current: string, next: string) {
    return apiClient.request('POST', '/api/auth/change-password', {
      body: JSON.stringify({ current, next }),
    });
  },

  /** List active sessions for the current user (used by T26 settings page). */
  listSessions() {
    return apiClient.request('GET', '/api/auth/sessions');
  },

  /** Revoke a specific session by id (used by T26 settings page). */
  revokeSession(sessionId: string) {
    return apiClient.request('DELETE', `/api/auth/sessions/${sessionId}`);
  },
};
